
import axios from 'config/axiosConfig'
import { get_with_last_assessment, go, testTakers, test_takers } from 'keys/apis'
import { TestTakerVM } from 'models/VM'
import { getAssessmentFilters, getTestTakerFilters } from 'utils/filtering'
import setFilters from 'config/filters'

export const getSchoolClassesFetch = (filters = {}) => {
    const params = getAssessmentFilters(filters)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}school_classes/`, {
        params: params
    })
}

export const getAllGradesFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}grades/all/`)
}


export const getLanguagesFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}languages/`)
}

export const getLearningGroupsFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}learning_groups/`)
}

export const getGradesFetch = (filters = {}) => {
    let params = getAssessmentFilters(filters)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}grades/`, {
        // params: params
    })
}

export const getMethods = ({ dispatch, getState }) => next => action => {
    if (action.type === 'GET_METHODS') {
        return new Promise((resolve, reject) => {
            axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}methods/`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.error(error);
                    reject(error)
                });
        })
    }
    return next(action)
}

export const getTestTakersOptionsFetch = (filters = {}) => {
    let params = getTestTakerFilters(filters)

    params = {
        ...params, ...setFilters(filters)
    }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}test_takers/options/`, {
        params: params
    })
}

export const getTestTakersFetch = (filters) => {
    const params = getTestTakerFilters(filters)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}test_takers/`, {
        params: params
    })
        .then((res) => {
            const test_takers =
                res?.data?.map(item => (new TestTakerVM(item)))
            return test_takers
        })
}

export const getAllTestTakersFetch = (filters) => {
    let params = getTestTakerFilters(filters)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}test_takers/`, {
        params: params
    })
}

export const getTestTakerOptionsWithClassFetch = (filters) => {
    let params = getTestTakerFilters(filters)

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}test_takers/options_with_class/`, {
        params: params
    })
}

export const saveTestTakerFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}test_takers/enroll/`, {
        ...values
    })
}

export const assignTestTakersToLearningGroupFetch = ({ test_taker_ids, learning_group_id }) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}test_takers/assign_to_learning_group/`, {
        test_taker_ids, learning_group_id
    })
}

export const searchTestTakerByTzFetch = (tz) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}test_takers_lookup/search_by_tz/`, {
        tz: tz
    })
}

export const updateOrCreateTestTakersFetch = (values) => {
    let formData = new FormData();

    Object.keys(values).map((key) =>
        formData.append(key, values[key])
    )

    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}test_takers/update_or_create_test_takers/`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

export const deleteLearningUnitFetch = (id) => {
    return axios.delete(`${process.env.REACT_APP_SERVER_PORT}${go}learning_units/${id}/delete_unit/`)
}

export const getWithLastAssessmentsFetch = ({ model, pageSize, sorting, search, headerFilters, assessmentFilters, signal, page }) => {
    let params = getTestTakerFilters(headerFilters)

    params = {
        ...params, ...setFilters({ model, page, pageSize, search, sorting })
    }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}${testTakers}${get_with_last_assessment}/`, {
        signal,
        params: params
    })
}

export const getTestTakers3Fetch = ({ model, filters, pageSize, sorting, search, headerFilters, signal, page }) => {
    let params = getAssessmentFilters(headerFilters, filters)
    
    params = {
        ...params, ...setFilters({ model, page, pageSize, search, sorting })
    }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}${testTakers}`, {
        signal,
        params: params
    })
}

export const getBasicTestTakersFetch = ({ model, pageSize, sorting, search, headerFilters, signal, page }) => {
    let params = getTestTakerFilters(headerFilters)

    params = {
        ...params, ...setFilters({ model, page, pageSize, search, sorting })
    }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}${testTakers}basic/`, {
        signal,
        params: params
    })
}

export const getTestTakers2Fetch = (filters) => {
    let params = getTestTakerFilters(filters)

    params = {
        ...params, ...setFilters(filters)
    }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}${testTakers}`, {
        params: params
    })
}

export const createGradeFetch = (data) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}grades/`, {
        ...data
    })
}

export const createClassFetch = (data) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}school_classes/`, {
        ...data
    })
}

export const getTestTakerFetch = (id) => {
    if (id)
        return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}${test_takers}/${id}/`)
}




